export default __webpack_public_path__ + "static/media/office2-afterA.ace2a748.jpg";